import { createCrudHooks } from '../../shared/api/crud-hooks';
import { clientsApi } from './api';
import type { ClientDto, ClientInput, ClientListItem } from './types';

export const clientsHooks = createCrudHooks<ClientListItem, ClientDto, ClientInput>({
  queryKey: ['clients'],
  api: clientsApi,
});
